<template>
    <div class="article">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>内容管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>文章管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <!--搜索区-->
            <el-card :visible.sync="contentVisible">
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="文章标题">
                        <el-input v-model="searchForm.title" placeholder="文章标题" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="文章关键字">
                        <el-input v-model="searchForm.keywords" placeholder="文章关键字" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="文章摘要">
                        <el-input v-model="searchForm.summary" placeholder="文章摘要" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="文章类型">
                        <el-select v-model="searchForm.category" placeholder="请选择文章类型" size="mini">
                            <el-option v-for="item in articleTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="账号状态" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="无效" value="0"></el-option>
                            <el-option label="有效" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary"
                                   @click="() => {this.currentPage=1;onSearch();}"
                                   size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                 <el-table
                    size="mini"
                    :height="tableConfig.height"
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column
                        prop="title"
                        label="标题"
                        width="300">
                    </el-table-column>
                     <el-table-column
                             prop="category"
                             label="分类"
                             width="100">
                     </el-table-column>
                     <el-table-column
                        prop="keywords"
                        label="关键字">
                    </el-table-column>
                     <el-table-column
                        prop="description"
                        label="描述"
                        width="180">
                    </el-table-column>
                     <el-table-column
                        prop="summary"
                        label="摘要"
                        width="180">
                    </el-table-column>
                     <el-table-column
                        prop="sortOrder"
                        label="文章排序"
                        width="180">
                    </el-table-column>
                    <el-table-column label="操作" width="350" align="right">
                        <template slot="header">
                            <el-button type="primary" size="mini" @click="handleCreateArticle">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text"
                                v-if="scope.row.status === 1"
                                size="mini"

                                @click="handleRevoke(scope.$index, scope.row)">下架</el-button>
                            <el-divider direction="vertical" v-if="scope.row.status === 1"></el-divider>
                            <el-button
                                v-if="scope.row.status === 0"
                                size="mini"
                                type="text"
                                @click="handlePublish(scope.$index, scope.row)">上架</el-button>
                            <el-divider direction="vertical" v-if="scope.row.status === 0"></el-divider>
                            <el-button
                                size="mini"
                                type="text"
                                @click="handleEdit(scope.$index, scope.row)">编辑文章</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button
                                size="mini"
                                type="text"
                                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
            <el-dialog title="编辑文章" :visible.sync="editDialogVisible" width="1000px" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="80px">
                    <el-form-item label="类型">
                        <el-select v-model="editForm.category" placeholder="请选择文章类型">
                            <el-option v-for="item in articleTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题">
                        <el-input v-model="editForm.title" placeholder="请输入标题" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="关键字">
                        <el-input v-model="editForm.keywords" placeholder="请输入关键字" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="摘要">
                        <el-input v-model="editForm.summary" placeholder="请输入摘要" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="描述">
                        <el-input v-model="editForm.description" placeholder="请输入描述" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="editForm.sortOrder" placeholder="请输入排序" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="内容">
                        <el-row>
                            <quill-editor
                                    v-model="editForm.content"
                                    :options="editorOption"
                                    ref="myQuillEditor">
                            </quill-editor>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="editForm.status" placeholder="请选择文章状态">
                            <el-option label="无效" value="0"></el-option>
                            <el-option label="有效" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="onSubmit">确 定</el-button>
                </div>
            </el-dialog>
        </main>

    </div>
</template>
<script>
import Quill from 'vue-quill-editor'
import {quillRedefine} from 'vue-quill-editor-upload'//引入图片上传
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {
                title: "",
                keywords: "",
                summary: "",
                category: "",
                status: "",
            },
            statusOptions: [
                {
                    value: "",
                    label: "全部",
                },
                {
                    value: "0",
                    label: "无效",
                },
                {
                    value: "1",
                    label: "有效",
                },
            ],
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            contentVisible: true,
            editForm: {
                id: "",
                code: "",
                category: "",
                title: "",
                keywords: "",
                description: "",
                summary: "",
                content: "",
                author: "",
                sortOrder: "",
                status: "1",
            },
            articleTypes: [],
            role: "",
            staffId: "",
            content:'',
            editorOption:{},
        }
    },
    methods: {
        onSearch() {
            let article = {
            };
            if(this.searchForm.title != "") {
                article["title"] = this.searchForm.title;
            }
            if(this.searchForm.keywords != "") {
                article["keywords"] = this.searchForm.keywords;
            }
            if(this.searchForm.description != "") {
                article["description"] = this.searchForm.description;
            }
            if(this.searchForm.category != "") {
                article["category"] = this.searchForm.category;
            }
            if(this.searchForm.summary != "") {
                article["summary"] = this.searchForm.summary;
            }
            if (this.searchForm.status != "") {
                article["status"] = this.searchForm.status;
            }
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/article/search",{
                cond: article,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function(error) {
            });
        },
        handleCreateArticle() {
            this.editForm.id = "";
            this.editForm.code = "";
            this.editForm.category = "";
            this.editForm.title = "";
            this.editForm.keywords = "";
            this.editForm.description = "";
            this.editForm.summary = "";
            this.editForm.content = "";
            this.editForm.author = "";
            this.editForm.sortOrder = "";
            this.editForm.status = "1";
            this.editDialogVisible = true;
            this.contentVisible = false;
        },
        onSubmit() {
            let _this = this;
            this.$axios.post("/admin/article/save", this.editForm)
            .then(function(response){
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.editDialogVisible = false;
                    _this.onSearch();
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        // handleEditRole(index, row) {
        //     let _this = this;
        //     this.staffId = row.id;
        //     this.$axios.get("/admin/article/" + row.id)
        //     .then(function(response) {
        //         let resp = response.data;
        //         if(resp.header.status == 0) {
        //             if(resp.data.length>0) {
        //                 _this.role = resp.data[0].id;
        //             } else {
        //                 _this.role = "";
        //             }
        //             _this.editRoleVisible = true;
        //         }
        //     })
        // },
        handleRevoke(index, row) {
            let that = this;
            this.$confirm('是否下架文章【' + row.title + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '下架',
                cancelButtonText: '取消'
            }).then(() => {
                let params = {...row, status: 0};
                that.$axios.post("/admin/article/save", params)
                .then(function(response){
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        handlePublish(index, row) {
            let that = this;
            this.$confirm('是否上架文章【' + row.title + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '上架',
                cancelButtonText: '取消'
            }).then(() => {
                let params = {...row, status: 1};
                that.$axios.post("/admin/article/save", params)
                .then(function(response){
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.code = row.code;
            this.editForm.category = row.category;
            this.editForm.title = row.title;
            this.editForm.keywords = row.keywords;
            this.editForm.description = row.description;
            this.editForm.summary = row.summary;
            this.editForm.content = row.content;
            this.editForm.author = row.author;
            this.editForm.sortOrder = row.sortOrder;
            this.editForm.status = row.status + "";
            this.editDialogVisible = true;
            this.contentVisible = false;
        },
        handleDelete(index, row) {
            let _this = this;
            this.$confirm('是否删除文章【' + row.title + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/article/delete/" + row.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        initArticleTypes() {
            let _this = this;
            this.$axios.get("/admin/article/articleTypeList")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.articleTypes.length = 0;
                        for(let i=0; i<resp.data.length; i++) {
                            let data = resp.data[i];
                            _this.articleTypes.push({
                                label: data.name,
                                value: data.code,
                            })
                        }
                    }
                })
        },
        initQuill() {
            let fonts = ['SimSun', 'SimHei','Microsoft-YaHei','KaiTi','FangSong','Arial','Times-New-Roman','sans-serif'];
            Quill.Quill.imports['formats/font'].whitelist=fonts;
            Quill.Quill.register(Quill.Quill.imports['formats/font']);

            const toolbarOptions = [
                ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
                [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
                [{ align: [] }], // 对齐方式-----[{ align: [] }]
                // [{ size: fontSizeStyle.whitelist }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
                [{ font: fonts }], // 字体种类-----[{ font: [] }]
                [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                [{ direction: 'ltl' }], // 文本方向-----[{'direction': 'rtl'}]
                [{ direction: 'rtl' }], // 文本方向-----[{'direction': 'rtl'}]
                [{ indent: '-1' }, { indent: '+1' }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
                [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
                [{ script: 'sub' }, { script: 'super' }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
                ['blockquote', 'code-block'], // 引用  代码块-----['blockquote', 'code-block']
                ['clean'], // 清除文本格式-----['clean']
                ['link', 'image'] // 链接、图片、视频-----['link', 'image', 'video']
            ];
            this.editorOption = quillRedefine({
                // 图片上传的设置
                uploadConfig: {
                    action: "/api/admin/upload",  // 必填参数 图片上传地址
                    res: (respnse) => {
                        return '/api'+ respnse.data.message;//return图片url
                    },
                    name: 'file'  // 图片上传参数名
                },
                toolOptions: toolbarOptions,
            })
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
        this.onSearch();
        this.initArticleTypes();
        this.initQuill();
    },
    mounted() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            loading.close();
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
</style>
